// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo-module--logo--pglgT","logoFixed":"HeaderLogo-module--logoFixed--QI-jm"};